import { render, staticRenderFns } from "./TablaTodos.vue?vue&type=template&id=2184b215&"
import script from "./TablaTodos.vue?vue&type=script&lang=js&"
export * from "./TablaTodos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports